module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"relationship_deletion":"Relationship deletion","confirm_deletion":"Are you sure you want to permanently delete this relationship ?"},"fr":{"relationship_deletion":"Suppression de la relation","confirm_deletion":"Êtes-vous sûr de vouloir définitivement supprimer cette relation ?"}}')
  delete Component.options._Ctor
}
